import Accordion from "@visa/vds/accordion";
import AccordionBody from "@visa/vds/accordion-body";
import AccordionHeading from "@visa/vds/accordion-heading";
import AccordionItem from "@visa/vds/accordion-item";
import AccordionTitle from "@visa/vds/accordion-title";
import React, { useRef } from "react";
import Post from "./Post";
import _uniqueId from "lodash/uniqueId";

function Category(props) {
    const { current: id } = useRef(_uniqueId("accordion-category-"));

    const renderChildren = () => {
        return (
            <AccordionItem>
                <AccordionHeading>
                    <AccordionTitle>{props.name}</AccordionTitle>
                </AccordionHeading>
                <AccordionBody>
                    {props.posts &&
                        props.posts.sort((a,b) => a.orderNumber - b.orderNumber).map((item, k) => (
                            <Post
                                displayPostId={props.displayPostId}
                                handleClickLinkBtn={props.handleClickLinkBtn}
                                key={k}
                                post={item}
                            />
                        ))}
                    {(!props.posts || props.posts.length === 0) && (
                        <span>No contents available.</span>
                    )}
                </AccordionBody>
            </AccordionItem>
        );
    }

    if (props.defaultExpanded) {
        return (
            <Accordion id={id} defaultExpandedId={[0]}>
                {renderChildren()}
            </Accordion>
        );
    }

    return (
        <Accordion id={id}>
            {renderChildren()}
        </Accordion>
    );
}

export default Category;
